import { render, staticRenderFns } from "./product-brands.modal.vue?vue&type=template&id=d0870d72&scoped=true&"
import script from "./product-brands.modal.vue?vue&type=script&lang=js&"
export * from "./product-brands.modal.vue?vue&type=script&lang=js&"
import style0 from "./product-brands.modal.vue?vue&type=style&index=0&id=d0870d72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0870d72",
  null
  
)

export default component.exports